// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#css__lnA\\+fE{background:transparent;margin-bottom:0!important;margin-top:0!important;padding-bottom:0!important;padding-top:0!important;position:relative}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page_content": "css__lnA+fE"
};
module.exports = ___CSS_LOADER_EXPORT___;
